import { CompanyDetails, DunsNumber } from '@customTypes/ItemTypes';
import { getCompanyDetails } from '@factories/companyInfo';

// export const GET_PROFILE_DETAILS = 'GET_PROFILE_DETAILS';
export const SET_COMPANY_INFO = 'SET_COMPANY_INFO';
export const CLEAR_COMPANY_INFO = 'CLEAR_COMPANY_INFO';

export const SET_COMPANY_INFO_IS_OPEN = 'SET_COMPANY_INFO_IS_OPEN';

// Selected Company info
export const SET_SELECTED_COMPANY_INFO = 'SET_SELECTED_COMPANY_INFO';

export function setCompanyInfo(value : CompanyDetails)
: {type : string; companyInfo : CompanyDetails} {
    return {
        type: SET_COMPANY_INFO,
        companyInfo: value
    };
}

export function clearCompanyInfo()
: { type : string; companyInfo : [] } {
    return {
        type: CLEAR_COMPANY_INFO,
        companyInfo: []
    };
}

export function getCompanyInfo(dunsNumber : DunsNumber, idaas_uuid?: string) {
    return (dispatch : any) => getCompanyDetails(dunsNumber, idaas_uuid, 'normal')
        .then(
            (company) => { if (company) dispatch(setCompanyInfo(company)); }
        );
}

export function setCompanyInfoIsOpen(value :boolean):any {
    return {
        type: SET_COMPANY_INFO_IS_OPEN,
        isCompanyInfoOpen: value
    };
}

export function setSelectedCompanyInfo(value: CompanyDetails):any {
    localStorage.setItem('selectedCompanyInfo', JSON.stringify(value));
    return {
        type: SET_SELECTED_COMPANY_INFO,
        selectedCompanyInfo: value
    };
}
